import { FC, useContext, useEffect } from 'react'

import { ImportOrdersContext } from '../ImportOrders.context'
import UploadFileStandard from './UploadFileStandard/UploadFileStandard'
import UploadFileVerticalHorizontal from './UploadFileVerticalHorizontal/UploadFileVerticalHorizontal'

const UploadFileProgressBar: FC<{
  nextStep: () => void
}> = ({ nextStep }) => {
  const { fileType, setModalTitle } = useContext(ImportOrdersContext)
  useEffect(() => setModalTitle(''), [setModalTitle])

  return (
    <>
      {fileType === 'standard' && <UploadFileStandard nextStep={nextStep} />}
      {(fileType.includes('Vertical') || fileType.includes('Horizontal')) && (
        <UploadFileVerticalHorizontal nextStep={nextStep} />
      )}
    </>
  )
}

export default UploadFileProgressBar
